import React from "react";
import { Tooltip } from "react-tooltip";

export default function TooltipComp({ tooltipId, tooltipTitle, tooltipDetail }) {
  const handleToolTipDetail = (detail) => {
    if (!detail) return null;

    const [part1, part2 = ""] = detail.split(".", 2); // Split only into 2 parts, default part2 to empty string if undefined
    const formattedPart2 = part2
      .split(" ")
      .map((word) => word.replace(/-/g, " - "));

    return (
      <>
        {part1 && `${part1}.`}{" "}
        {/* Ensure part1 is always followed by a period */}
        <br />
        <br />
        {formattedPart2.length > 0 && formattedPart2[0]}
        <br />
        {formattedPart2.length > 1 && formattedPart2[1]}
      </>
    );
  };

  return (
    <>
      {/* <div className="relative flex flex-col items-center group cursor-pointer hover:text-white">
        <div className="w-4 h-4 md:w-5 md:h-5 *:w-full *:h-full">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
          >
            <path
              d="M10.9997 20.1667C16.0413 20.1667 20.1663 16.0417 20.1663 11C20.1663 5.95837 16.0413 1.83337 10.9997 1.83337C5.95801 1.83337 1.83301 5.95837 1.83301 11C1.83301 16.0417 5.95801 20.1667 10.9997 20.1667Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11 7.33337V11.9167"
              stroke="#FFF5F5"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.9951 14.6666H11.0034"
              stroke="#FFF5F5"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="absolute bottom-[10px] hidden group-hover:flex flex-col items-center mb-5 min-w-[150px] laptop:min-w-[285px] duration-500">
          <span className="relative rounded-[8px] z-10 p-2 lg:p-3 text-black whitespace-no-wrap bg-white shadow-tooltip">
            <h5 className="text-xs lg:text-sm font-semibold leading-none mb-2">
              {tooltipTitle}
            </h5>
            <p className="text-[10px] lg:text-[14px] font-medium">
              {tooltipDetail}
            </p>
          </span>
          <div className="w-3 h-3 -mt-2 rotate-45 bg-white"></div>
        </div>
      </div> */}

      <div className="relative flex flex-col cursor-pointer self-start md:self-auto pt-[2px] md:pt-0 ml-auto md:ml-0">
        <div
          className="w-3 h-3 md:w-[22px] md:h-[22px] *:w-full *:h-full text-[#FFF5F566]/35 hover:text-white/80"
          id={tooltipId}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
          >
            <path
              d="M10.9997 20.1667C16.0413 20.1667 20.1663 16.0417 20.1663 11C20.1663 5.95837 16.0413 1.83337 10.9997 1.83337C5.95801 1.83337 1.83301 5.95837 1.83301 11C1.83301 16.0417 5.95801 20.1667 10.9997 20.1667Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11 7.33337V11.9167"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.9951 14.6666H11.0034"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <Tooltip
          anchorSelect={`#${tooltipId}`}
          place="top"
          type="light"
          effect="solid"
          className="!bg-white !text-[#06080C] !opacity-100 shadow-tooltip !rounded-[8px] !p-2 lg:!p-3 !w-[150px] laptop:!w-[285px]"
        >
          <h5 className="text-xs lg:text-sm font-semibold leading-none mb-2 capitalize">
            {tooltipTitle}
          </h5>
          <p className="text-[10px] lg:text-[14px] font-medium break-words">
            {tooltipTitle === "last checkpoint"
              ? handleToolTipDetail(tooltipDetail)
              : tooltipDetail}
          </p>
        </Tooltip>
      </div>
    </>
  );
}
